
import { defineComponent } from 'vue'
import hemisphereService from '@/services/hemisphere.service'
import useVuelidate from '@vuelidate/core'
import { sameAs, not } from '@vuelidate/validators'
import { required, email, withI18nMessage } from '@/utils/i18n-validators'
import { useSession } from '@/composables/auth'

export default defineComponent({
  setup() {
    let { user } = useSession()
    return {
      v$: useVuelidate(),
      user
    }
  },
  data() {
    return {
      dialogVisible: false,
      newMail: '',
      oldemail: 'test',
      emailSent: false,
      invalidEmail: undefined as string | undefined
    }
  },
  validations() {
    let email_differ = not(sameAs(this.user.email))
    email_differ = withI18nMessage(email_differ)
    return {
      oldemail: {},
      newMail: {
        required,
        email,
        email_differ
      }
    }
  },
  computed: {
    closable(): boolean {
      return this.emailSent
    },
    errorMessage() {
      let newMailValidator: any = this.v$.newMail
      if (newMailValidator.$error) {
        return newMailValidator.$errors[0].$message
      }
      if (this.invalidEmail && this.invalidEmail == this.newMail) {
        return this.$t('validations.email_already_used')
      }
      return undefined
    }
  },
  methods: {
    setVisible(visible: boolean) {
      this.dialogVisible = visible
      this.$emit('update:visible', visible)
      if (!visible) {
        this.reset()
      }
    },
    hide() {
      this.setVisible(false)
    },
    show() {
      this.setVisible(true)
      this.emailSent = false
    },
    reset() {
      this.emailSent = true
      this.newMail = ''
      this.v$.$reset()
    },
    async changeMail() {
      const isFormCorrect = await this.v$.$validate()
      if (!isFormCorrect) {
        return
      }
      try {
        await hemisphereService.updateEmail(this.newMail)
        console.log('mail sent', this.newMail)
        this.emailSent = true
      } catch (error) {
        this.invalidEmail = this.newMail
        console.log(error)
      }
    }
  }
})
